import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { HbsmrIdentity, HbsmrUser } from "./HbsmrUser";
import { TextPacks, TextPackLoader } from "./TextPackLoader";
import { MapBase } from "./MapBase";
import { MapOptions, IMap, MapLayerSwitcher, MapFeatureInfo, IMapAreaMask, ILogger, IMapFactory, IResourceFactory, MapListRecordsInViewport, IMapListRecordItem, IMappingTextPack, MapFactory, Logger } from "esdm-map";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { GeoNames } from "esdm-map/dist/gazetteer/geonames";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IWmsLayerGroupFactory, IWmsLayerGroupConfig } from "esdm-map/dist/layers/groups/wms/interfaces";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { WmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { CustomClient_BaseLayerFactory_27700 } from "./CustomClient_BaseLayerFactory_27700";
import { GeoJsonFeatureLoader, FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { BuckinghamshireMapListRecordItem } from "./BuckinghamshireMapListRecordItem";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { BuckinghamshireRecordType, BuckinghamshireRecordSubType } from "./BuckinghamshireRecordTypes";

import { GeoLocation } from "esdm-map/dist/map/geolocation";
import { MapViewSettingsUrlProvider} from "esdm-map/dist/map/store/MapViewSettingsUrlProvider"
import { IMapViewPermaLink, MapViewPermaLink} from "esdm-map/dist/map/tools"

//import "../wwwroot/css/ol.css";
//import "../wwwroot/css/bootstrap-slider.min.css";
//import "../wwwroot/css/ol-contextmenu.css";

import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { IVectorLayerGroupLoadedEventArgs } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupEvents";
import { Tooltip } from "bootstrap";
import { debounce } from "debounce";

$(function () {  

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
    
    let printOptions: PrintMap = new PrintMap();

    if (!printOptions.isPrintMap) {        
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250)); 
    } 

    function resizeMap() {
        //use max footer height, especially on mobile
        let fHeight = $("footer").height();
        fHeight = Math.min(fHeight, 200);

        let height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
        $("#slide-content").height(height - 55);
    };



    let ele = $("#theMap");
    if (ele.length === 1) {      
        HbsmrIdentity.fetch().then(function (e) {
            //let user = e;
            //if (e) {
            //    console.log(e.userId);
            //} else {
            //    console.log("401 - UnAuthorised");
            //}
            loadMap(e);
        });
    } 

    function loadMap(user: HbsmrUser) {
        let maxFeatureCount: number = <number>ele.data("max-feature-count");
        let init = function (textpacks: TextPacks) {
            let map = new MainMap("theMap", maxFeatureCount, printOptions, textpacks.mapping, user);
        }
        TextPackLoader.load().then(init);
    }

});

export class MainMap extends MapBase {
        
    private mfOptions: MapOptions;
    public map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private infoPopup: MapFeatureInfo;
    private initialised: boolean = false;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;
    private geoNames: GeoNames;
    private gridRefFinder: GridRef;
    private logger: ILogger;   
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private wmsLayerGroupFactory: IWmsLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;    
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private recordList: MapListRecordsInViewport;
    private geoLocation: GeoLocation;
    private extentsNavigation: ExtentsNavigation;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mapViewSettingProvider: MapViewSettingsUrlProvider;
    private mapListRecordItem: IMapListRecordItem;
    private mapViewPermaLink: IMapViewPermaLink;
    private mousePosition: MousePosition;

    public constructor(
        public mapElementId: string,       
        public maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: HbsmrUser)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = (): void => {
        if (!this.initialised) {
            //strip-loader should take this out for production
            console.log("Initialising main map");                       

            this.layerConfigFactory = new DefaultLayerConfigurationFactory();
            this.wmsLayerGroupFactory = new WmsLayerGroupFactory();
            this.vectorLayerGroupFactory = new VectorLayerGroupFactory(); 
            this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, this.wmsLayerGroupFactory);
            this.baseLayerFactory = new CustomClient_BaseLayerFactory_27700();            
            this.featureLoader = new GeoJsonFeatureLoader();
            this.featureAdd = new FeatureAddSmallGeomsAsPoint(4.5);
            this.mapFilter = new MapFilters();
            this.mapFilter.OgcFilter = new OgcMapFilter();
            this.mapFactory = new MapFactory();
            this.logger = new Logger();           
            this.styleFactory = new HbsmrStyleFactory();
            this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack, this.user);

            this.mfOptions = DefaultMapOptions.GetDefaultOptions(this.mapElementId, "MainMap");           
            this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
            this.mfOptions.layerGroupCollection = this.layerGroups;
            
            this.mapViewSettingProvider = new MapViewSettingsUrlProvider();
            this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey, this.mapViewSettingProvider);
            
            this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);            
            this.mapContextMenu = new MapContextMenu(this.mappingTextPack);

            this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
            this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);                        
            this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);

            this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack,
                {
                    showOpenPanelByDefault: !this.printOptions.isPrintMap,
                    rememberActivePanel: true
                });
            this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
            this.geoNames = new GeoNames(this.map, this.mappingTextPack, 16);   

            if (this.printOptions.isPrintMap) {                
                this.printOptions.setMap(this.map);
            } 

            this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
            this.mapListRecordItem = new BuckinghamshireMapListRecordItem(this.mappingTextPack, this.user);
            this.recordList = new MapListRecordsInViewport(this.map, this.mapStore, this.styleFactory, this.layerGroups.vectorLayerGroups, this.mappingTextPack, 15, this.mapListRecordItem);
            this.geoLocation = new GeoLocation(this.map, this.logger, this.mappingTextPack);
            this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
            this.mousePosition = new MousePosition(this.map, this.mappingTextPack);
            this.mapViewPermaLink = new MapViewPermaLink(this.map, this.mapViewSettingProvider, this.mappingTextPack, { activePanel: "overlays" });

            this.setWmsOpactity(this.map);

            this.initialised = true;


            //let options = null;
            //let parser = new ol.format.WMTSCapabilities();
            //fetch('https://maps.buckscc.gov.uk/arcgis/rest/services/Bucks_Basemapping/MapServer/WMTS/1.0.0/WMTSCapabilities.xml')
            //    .then(function (response) {
            //        return response.text();
            //    })
            //    .then(function (text) {
            //        let result = parser.read(text);
            //        options = ol.source.WMTS.optionsFromCapabilities(result, {
            //            layer: 'Bucks_Basemapping',
            //            matrixSet: 'default028mm'
            //        });
            //        debugger;                    
            //    });

        }
    }


    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {       


        //let bucks1wms: IWmsLayerGroupConfig = {
        //    displayName: "WMS - county boundaries",
        //    ref: "CountyBoundariesWms",
        //    type: BuckinghamshireRecordType.Monument,
        //    url: "/api/ogcservice/BucksWms",
        //    visibleOnFirstLoad: true,
        //    queryable: true,
        //    info_format: "text/html",
        //    layers: [
        //        {
        //            layerName: "12",                    
        //            minZoom: 1,
        //            maxZoom: 19                    
        //        }
        //    ]
        //};

        let layerGroupConfig: Array<IVectorLayerGroupConfig | IWmsLayerGroupConfig> = [            
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Monument, null, { visibleOnFirstLoad: true }),
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Event),            
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Consultation),
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Designation, BuckinghamshireRecordSubType.ScheduledMonument),
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Designation, BuckinghamshireRecordSubType.ListedBuilding),                             
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Designation, BuckinghamshireRecordSubType.RegisteredParksAndGardens),            
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Designation, BuckinghamshireRecordSubType.ConservationArea),
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Designation, BuckinghamshireRecordSubType.LocallyListedBuilding),
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Designation, BuckinghamshireRecordSubType.ArchaeologicalNotificationAreas),            
            this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.HistoricRidgeAndFurrow)
        ];      

        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: false,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            },
            {
                ref: "hlc_1820",
                name: "HLC 1820",
                useAccordion: true,
                expandedOnFirstLoad: false,
                layerGroupConfigs: [
                    this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Hlc_1820)
                ]
            },
            {
                ref: "hlc_1880",
                name: "HLC 1880",
                useAccordion: true,
                expandedOnFirstLoad: false,
                layerGroupConfigs: [
                    this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Hlc_1880)
                ]
            },
            {
                ref: "hlc_2000",
                name: "HLC 2000",
                useAccordion: true,
                expandedOnFirstLoad: false,
                layerGroupConfigs: [
                    this.layerConfigFactory.layerConfig(BuckinghamshireRecordType.Hlc_2000)
                ]
            }
        ];
    }

}




